import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "14",
  fill: "none",
  viewBox: "0 -1 16 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5.565 12.977c.647 0 1.171-.466 1.171-1.04s-.524-1.04-1.171-1.04-1.171.466-1.171 1.04.524 1.04 1.17 1.04Zm7.613 0c.647 0 1.172-.466 1.172-1.04s-.525-1.04-1.172-1.04-1.171.466-1.171 1.04.524 1.04 1.171 1.04M1.465 1.023h2.343l1.57 6.96c.053.239.2.453.414.606s.482.235.757.23h5.692a1.27 1.27 0 0 0 .757-.23c.215-.153.361-.367.415-.607l.937-4.36H4.393"
    }, null, -1)
  ])))
}
export default { render: render }